import { render, staticRenderFns } from "./pre_switch.vue?vue&type=template&id=d86f8204&scoped=true"
import script from "./pre_switch.vue?vue&type=script&lang=js"
export * from "./pre_switch.vue?vue&type=script&lang=js"
import style0 from "./pre_switch.vue?vue&type=style&index=0&id=d86f8204&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86f8204",
  null
  
)

export default component.exports